import { Component, Host, h, Prop, JSX, Event, EventEmitter } from '@stencil/core'

@Component({
    tag: 'zr-accordion',
    styleUrl: 'zr-accordion.scss',
    scoped: true,
})

/**
 * ZooRoyal accordion  layout component.
 */
export class ZrAccordion {
    /**
     * The text of a single accordion heading.
     */
    @Prop() heading: string

    /**
     * The content which is to be parsed into the corrosponding accordion panels.
     */
    @Prop() content: string

    /**
     * The index of the current accordion which will undergo state-changes.
     */
    @Prop() index: number

    /**
     * The active-state to change the visibility of a single accordion.
     */
    @Prop() isActive = false

    /**
     * A property to receive a function for opening the accordion.
     */
    @Event() activeStateToggled: EventEmitter<boolean>

    /**
     * Function open and closes the accordion.
     */
    private toggleAccordion = () => {
        this.activeStateToggled.emit()
    }

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class={{
                    'zr-accordion': true,
                    'is-active': this.isActive,
                }}>
                    <div
                        class="zr-accordion__header"
                        onClick={this.toggleAccordion}
                        role="heading"
                        aria-level="2"
                        aria-expanded={this.isActive ? 'true' : 'false'}
                        aria-controls={'zr-accordion__panel-id-' + this.index}
                    >
                        <button class="zr-accordion__header-text">
                            {this.heading}
                        </button>
                    </div>
                    <div
                        class="zr-accordion__panel"
                        id={'zr-accordion__panel-id-' + this.index}
                    >
                        {typeof this.content === 'object'
                            ?this.content
                            :<div innerHTML={this.content} />
                        }
                    </div>
                </div>
            </Host>
        )
    }
}

